/**
 * Utility function to get the correct path for assets regardless of deployment location
 * This ensures assets work both in development and when deployed to a subfolder
 */
export const getAssetPath = (path: string): string => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  return `${process.env.PUBLIC_URL}/${cleanPath}`;
};
